import {
  SHIPPING_RATE_GROUPS,
  PRIMARY_COUNTRY_ORDER,
  GROUP_DISPLAY_ORDER,
} from '@theme/shipping-rates';

function formatAmount(cents, symbol) {
  return `${symbol}${(cents / 100).toFixed(2).replace('.', ',')}`;
}

function buildDisplayGroup(id, freeLabel) {
  const group = SHIPPING_RATE_GROUPS[id];
  return {
    id,
    flag: group.flag,
    name: group.name,
    carrierLabel: group.carrierLabel,
    carrier: group.carrier,
    tiers: group.tiers.map(tier => ({
      rangeText:
        tier.max === Infinity
          ? `${formatAmount(tier.min, group.currency)}+`
          : `${formatAmount(tier.min, group.currency)} - ${formatAmount(tier.max, group.currency)}`,
      costText: tier.cost === 0 ? freeLabel : formatAmount(tier.cost, group.currency),
      note: tier.note,
    })),
  };
}

/**
 * Alpine component backing snippets/shipping-content.liquid.
 * Renders the per-country shipping tier table from the single
 * shipping-rates.js data source: the visiting customer's own country
 * first (if it's one of the named countries), then every other group.
 */
export default function shippingContent({ customerCountry, freeLabel } = {}) {
  return {
    primary: null,
    others: [],

    init() {
      const code = (customerCountry || '').toLowerCase();
      const primaryId = PRIMARY_COUNTRY_ORDER.includes(code) ? code : null;

      this.primary = primaryId ? buildDisplayGroup(primaryId, freeLabel) : null;
      this.others = GROUP_DISPLAY_ORDER.filter(id => id !== primaryId).map(id =>
        buildDisplayGroup(id, freeLabel),
      );
    },
  };
}

let registered = false;
function registerShippingContent() {
  if (registered || !window.Alpine) return;
  registered = true;
  window.Alpine.data('shippingContent', shippingContent);
}

document.addEventListener('alpine:init', registerShippingContent);
if (window.Alpine) registerShippingContent();
